function simPROGeocoder(options) {
  var self = this;

  this.setValues = function (options) {
    this.provider = options.provider ? options.provider : 'none';
    this.key = options.key;
    this.batchResults = Array();
    this.batchErrors = Array();
    this.timezone = options.timezone ? options.timezone : '';
  };

  this.autoComplete = function (query, callback, options) {
    let key = this.key;
    let url = 'https://api.locationiq.com/v1/autocomplete.php?normalizecity=true&dedupe=1&limit=20&key=' + key + '&q=' + query;
    if (options) {
      if (options.country) {
        let countryFieldLowerCase = options.country.toLowerCase();
        if (countryFieldLowerCase in countryNamesWithCodes) {
          url += "&countrycodes=" + countryNamesWithCodes[countryFieldLowerCase];
        }
      }
      if (options.v3) {
        url += '&source=v3';
      }

      if (options.viewBox) {
        let viewBox = options.viewBox;
        url += "&viewbox=" + viewBox.lng + "," + viewBox.lat + "," + viewBox.lng + "," + viewBox.lat;
      }
      if (options.statecode) {
        url += "&statecode=1";
      }
    }
    $.ajax({
      "url": url,
      "method": "GET",
      "async": true,
      "crossDomain": true,
      success: function (response) {
        callback(response, 'OK');
      },
      error: function (xhr, textStatus, errorThrown) {
        callback(xhr.responseJSON, 'ERROR');
      }
    });
  };

  this.geocode = function (address, callback, identifier) {
    let key = this.key;
    let biasedAddress = this.preprocessAddressToCountryBias(address);
    let cachedAddress = window.localStorage.getItem(address);
    let jsonCachedAddress = cachedAddress ? JSON.parse(cachedAddress) : null;
    if (jsonCachedAddress && (identifier === null || jsonCachedAddress.id === identifier)) {
      callback([jsonCachedAddress], 'OK');
      return;
    }
    let url = 'https://' + getLocationIQServerLocale(this.timezone) + '.locationiq.com/v1/search.php?key=' + key + '&q=' + biasedAddress + '&format=json';
    $.ajax({
      url: url,
      dataType: 'json',
      tryCount: 0,
      retryLimit: 3,
      success: function (response) {
        let result = self.processResponse(response, identifier);
        try {
          window.localStorage.setItem(address, JSON.stringify(result[0]));
        } catch (e) {
          // local storage likely full, clear data and start again.
          window.localStorage.clear();
        }
        callback(result, 'OK');
      },
      error: function (xhr, textStatus, errorThrown) {
        if (xhr.status === 401) {
          this.tryCount++;
          if (this.tryCount <= this.retryLimit) {
            // retry is instantaneous, which doesnt really matter since requests where trhottled from start
            // however there are still better ways to to do this.
            $.ajax(this);
            return;
          }
        }
        callback(xhr.responseJSON, 'ERROR');
      }
    });
  };

  this.onGeocode = function (result, status) {
    if (status === 'OK') {
      self.batchResults.push(result[0])
    } else {
      self.batchErrors.push(result);
      self.batchRequestFailed = true;
    }
    self.requestsCount--;
    if (self.requestsCount === 0) {
      if (self.batchRequestFailed) {
        self.batchGeocodeCallback(self.batchResults, 'ERROR', self.batchErrors);

      } else {
        // sorting the array cause the last entry is the jobsite
        //self.batchResults.sort(function(a, b){return a.id-b.id})
        self.batchGeocodeCallback(self.batchResults, 'OK');
      }
    }
  };

  /**
   * make a batch of geocoding
   * @param addresses
   */
  this.batchGeocode = function (addresses, callback) {
    //self = this;
    this.batchResults = [];
    this.batchErrors = [];
    this.requestsCount = addresses.length;
    this.batchGeocodeCallback = callback;

    for (let i = 0; i < addresses.length; i++) {
      this.geocode(addresses[i].address, self.onGeocode, addresses[i].employeeID);
    }
  };

  this.processResponse = function (response, identifier) {
    var result = Array();
    for (let count in response) {
      var tempResult = {};
      tempResult.formatted_address = response[count].display_name;
      tempResult.geometry = {
        location: {
          "lat": response[count].lat,
          "lng": response[count].lon
        },
        "location_type": "ROOFTOP",
        "viewport": {
          "northeast": {
            "lat": response[count].boundingbox[1],
            "lng": response[count].boundingbox[3]
          },
          "southwest": {
            "lat": response[count].boundingbox[0],
            "lng": response[count].boundingbox[2]
          }
        }
      };
      tempResult.place_id = response[count].place_id;
      tempResult.types = [response[count].type];

      if (identifier != null) {
        tempResult.id = identifier;
      }

      result.push(tempResult);
    }

    return result;
  };
  const countryNamesWithCodes = {
    "andorra": "AD",
    "united arab emirates": "AE",
    "afghanistan": "AF",
    "antigua and barbuda": "AG",
    "anguilla": "AI",
    "albania": "AL",
    "armenia": "AM",
    "netherlands antilles": "AN",
    "angola": "AO",
    "antarctica": "AQ",
    "argentina": "AR",
    "american samoa": "AS",
    "austria": "AT",
    "australia": "AU",
    "aruba": "AW",
    "aland islands": "AX",
    "azerbaijan": "AZ",
    "bosnia and herzegovina": "BA",
    "barbados": "BB",
    "bangladesh": "BD",
    "belgium": "BE",
    "burkina faso": "BF",
    "bulgaria": "BG",
    "bahrain": "BH",
    "burundi": "BI",
    "benin": "BJ",
    "saint-barthélemy": "BL",
    "bermuda": "BM",
    "brunei darussalam": "BN",
    "bolivia": "BO",
    "bonaire": "BQ",
    "brazil": "BR",
    "bahamas": "BS",
    "bhutan": "BT",
    "botswana": "BW",
    "belarus": "BY",
    "belize": "BZ",
    "canada": "CA",
    "cocos (keeling) islands": "CC",
    "zaire": "CD",
    "central african republic": "CF",
    "congo": "CG",
    "switzerland": "CH",
    "côte d'ivoire": "CI",
    "cook islands": "CK",
    "chile": "CL",
    "cameroon": "CM",
    "china": "CN",
    "colombia": "CO",
    "costa rica": "CR",
    "cuba": "CU",
    "cape verde": "CV",
    "curaçao": "CW",
    "christmas island": "CX",
    "cyprus": "CY",
    "czech republic": "CZ",
    "czechia": "CZ",
    "germany": "DE",
    "djibouti": "DJ",
    "denmark": "DK",
    "dominica": "DM",
    "dominican republic": "DO",
    "algeria": "DZ",
    "ecuador": "EC",
    "estonia": "EE",
    "egypt": "EG",
    "western sahara": "EH",
    "eritrea": "ER",
    "spain": "ES",
    "ethiopia": "ET",
    "finland": "FI",
    "fiji": "FJ",
    "falkland islands": "FK",
    "micronesia": "FM",
    "faroe islands": "FO",
    "france": "FR",
    "gabon": "GA",
    "grenada": "GD",
    "georgia": "GE",
    "french guiana": "GF",
    "guernsey": "GG",
    "ghana": "GH",
    "gibraltar": "GI",
    "greenland": "GL",
    "gambia": "GM",
    "guinea": "GN",
    "guadeloupe": "GP",
    "equatorial guinea": "GQ",
    "greece": "GR",
    "sgssi": "GS",
    "guatemala": "GT",
    "guam": "GU",
    "guinea-bissau": "GW",
    "guyana": "GY",
    "hong kong": "HK",
    "honduras": "HN",
    "croatia": "HR",
    "haiti": "HT",
    "hungary": "HU",
    "indonesia": "ID",
    "ireland": "IE",
    "israel": "IL",
    "isle of man": "IM",
    "india": "IN",
    "british indian ocean territory": "IO",
    "iraq": "IQ",
    "iran": "IR",
    "iceland": "IS",
    "italy": "IT",
    "jersey": "JE",
    "jamaica": "JM",
    "jordan": "JO",
    "japan": "JP",
    "kenya": "KE",
    "kyrgyzstan": "KG",
    "cambodia": "KH",
    "kiribati": "KI",
    "comoros": "KM",
    "saint kitts and nevis": "KN",
    "north korea": "KP",
    "south korea": "KR",
    "kosovo": "KS",
    "kuwait": "KW",
    "cayman islands": "KY",
    "kazakhstan": "KZ",
    "lao pdr": "LA",
    "lebanon": "LB",
    "saint lucia": "LC",
    "liechtenstein": "LI",
    "sri lanka": "LK",
    "liberia": "LR",
    "lesotho": "LS",
    "lithuania": "LT",
    "luxembourg": "LU",
    "latvia": "LV",
    "libya": "LY",
    "morocco": "MA",
    "monaco": "MC",
    "moldova": "MD",
    "montenegro": "ME",
    "saint martin (french part)": "MF",
    "madagascar": "MG",
    "marshall islands": "MH",
    "north macedonia": "MK",
    "mali": "ML",
    "myanmar": "MM",
    "mongolia": "MN",
    "macao": "MO",
    "northern mariana islands": "MP",
    "martinique": "MQ",
    "mauritania": "MR",
    "montserrat": "MS",
    "malta": "MT",
    "mauritius": "MU",
    "maldives": "MV",
    "malawi": "MW",
    "mexico": "MX",
    "malaysia": "MY",
    "mozambique": "MZ",
    "namibia": "NA",
    "new caledonia": "NC",
    "niger": "NE",
    "norfolk island": "NF",
    "nigeria": "NG",
    "nicaragua": "NI",
    "netherlands": "NL",
    "norway": "NO",
    "nepal": "NP",
    "nauru": "NR",
    "niue": "NU",
    "new zealand": "NZ",
    "north island": "NZ",
    "oman": "OM",
    "panama": "PA",
    "peru": "PE",
    "french polynesia": "PF",
    "papua new guinea": "PG",
    "philippines": "PH",
    "pakistan": "PK",
    "poland": "PL",
    "saint pierre and miquelon": "PM",
    "pitcairn": "PN",
    "puerto rico": "PR",
    "palestinian territory": "PS",
    "portugal": "PT",
    "palau": "PW",
    "paraguay": "PY",
    "qatar": "QA",
    "réunion": "RE",
    "romania": "RO",
    "serbia": "RS",
    "russian federation": "RU",
    "rwanda": "RW",
    "saudi arabia": "SA",
    "solomon islands": "SB",
    "seychelles": "SC",
    "sudan": "SD",
    "sweden": "SE",
    "singapore": "SG",
    "saint helena": "SH",
    "slovenia": "SI",
    "svalbard and jan mayen islands": "SJ",
    "slovakia": "SK",
    "sierra leone": "SL",
    "san marino": "SM",
    "senegal": "SN",
    "somalia": "SO",
    "suriname": "SR",
    "south sudan": "SS",
    "sao tome and principe": "ST",
    "el salvador": "SV",
    "saint martin (dutch part)": "SX",
    "syria": "SY",
    "swaziland": "SZ",
    "turks and caicos islands": "TC",
    "chad": "TD",
    "french southern territories": "TF",
    "togo": "TG",
    "thailand": "TH",
    "tajikistan": "TJ",
    "tokelau": "TK",
    "timor-leste": "TL",
    "turkmenistan": "TM",
    "tunisia": "TN",
    "tonga": "TO",
    "turkey": "TR",
    "trinidad and tobago": "TT",
    "tuvalu": "TV",
    "taiwan": "TW",
    "tanzania": "TZ",
    "ukraine": "UA",
    "uganda": "UG",
    "united kingdom": "GB",
    "england": "GB",
    "great britain": "GB",
    "uk": "GB",
    "united kingdom of great britain and northern ireland": "GB",
    "us minor outlying islands": "UM",
    "united states of america": "US",
    "usa": "US",
    "u.s.": "US",
    "u.s.a.": "US",
    "america": "US",
    "united states": "US",
    "uruguay": "UY",
    "uzbekistan": "UZ",
    "vatican": "VA",
    "holy see": "VA",
    "saint vincent and grenadines": "VC",
    "venezuela": "VE",
    "british virgin islands": "VG",
    "virgin islands (british)": "VG",
    "virgin islands (u.s.)": "VI",
    "viet nam": "VN",
    "vanuatu": "VU",
    "wallis and futuna islands": "WF",
    "samoa": "WS",
    "yemen": "YE",
    "mayotte": "YT",
    "south africa": "ZA",
    "zambia": "ZM",
    "zimbabwe": "ZW"
  };
  this.preprocessAddressToCountryBias = function(address) {
    //https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2


    //In order to get better result to prevent makers flying to other countries
    //Find the matching country code and add region bias
    var regionCode = null;
    var strippedAddress = "";

    if (address) {
      var explodedAddressArray = address.split(", ");
      if (explodedAddressArray.length > 1) {
        var countryField = explodedAddressArray[explodedAddressArray.length - 1];
        countryField = countryField.replace(/^\s+|\s+$/gm, '');
        var countryFieldLowerCase = countryField.toLowerCase();
        if (countryFieldLowerCase in countryNamesWithCodes) {
          regionCode = countryNamesWithCodes[countryFieldLowerCase];
        } else {
          var countryFieldUpperCase = countryField.toUpperCase();
          for (var key in countryNamesWithCodes) {
            if (countryFieldUpperCase === countryNamesWithCodes[key]) {
              regionCode = countryFieldUpperCase;
              break
            }
          }
        }
      }
    }

    if (regionCode !== null) {
      explodedAddressArray.pop();
      strippedAddress = explodedAddressArray.join(", ");
      address = encodeURIComponent(strippedAddress);
      return address + "&countrycodes=" + regionCode;
    } else {
      return encodeURIComponent(address);
    }
  }

  this.setValues(options);
}
